import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import NullableValue from "../../../../Utils/renderField/nullableValue";
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const ConsumidoresFinalesTable = ({
    consumidoresFinales = [],
    EliminarConsumidorFinal,
}) => {
    return (
        <div className="new-table-wrapper consumidores-finales__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Acciones</th>
                        <th>Nombre</th>
                        <th>Clientes asociados</th>
                        <th>Fecha de creación</th>
                        <th>Última actualización</th>
                    </tr>
                </thead>
                <tbody>
                    {consumidoresFinales.length === 0 && (
                        <tr>
                            <td colSpan={5} className="text-center">
                                No hay consumidores finales para mostrar
                            </td>
                        </tr>
                    )}
                    {consumidoresFinales.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <div className="table-actions">
                                        <Link
                                            to={`/clientes/consumidores-finales/${item.id}/editar`}
                                        >
                                            <img
                                                src={editarIcon}
                                                alt="Editar"
                                                className="action_img"
                                                title="Editar"
                                            />
                                        </Link>
                                        <img
                                            src={eliminarIcon}
                                            alt="Eliminar"
                                            className="action_img"
                                            title="Eliminar"
                                            onClick={() =>
                                                EliminarConsumidorFinal(item.id)
                                            }
                                        />
                                    </div>
                                </td>
                                <td className="text-center">{item.nombre}</td>
                                <td className="text-center">
                                    {item.total_clientes}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.fecha_creacion}>
                                        {moment(item.fecha_creacion).format(
                                            "DD/MM/YYYY HH:mm",
                                        )}
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.fecha_actualizacion}
                                    >
                                        {moment(
                                            item.fecha_actualizacion,
                                        ).format("DD/MM/YYYY HH:mm")}
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
